function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loginObj } from '@/services/base';
import axios from 'axios';
import tasks from '@/js/tasks';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['master_data']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8090')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
var beforeMiddleware = function beforeMiddleware(config) {
  // tasks.getUserInfo()
  config.headers['Authorization'] = 'Bearer ' + window.userInfo.accessToken;
  return config;
};

//appApisGTW.before(beforeMiddleware)
setupInterceptors(appApisGTW);
var MICROSERVICE_NAME = '/master_data';
var CONTROLLER_NAME = '/domain';
var DOMAIN_ORGANIZATIONS = '/organizations';
export default {
  getOrganizations: function getOrganizations() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(MICROSERVICE_NAME).concat(CONTROLLER_NAME).concat(DOMAIN_ORGANIZATIONS, "/get_all"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  getOrganizationsDetail: function getOrganizationsDetail() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$lock = _ref.lock,
      lock = _ref$lock === void 0 ? true : _ref$lock;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    if (lock) tasks.lockScreen.lock();
    return appApisGTW.post("".concat(MICROSERVICE_NAME).concat(CONTROLLER_NAME).concat(DOMAIN_ORGANIZATIONS, "/get_all_detail"), body).then(function (response) {
      response.data.data.sort(function (a, b) {
        var nameA = a.alias.toUpperCase(); // ignore upper and lowercase
        var nameB = b.alias.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });
      return response.data;
    }).catch(function (err) {
      console.info(err);
    }).finally(function () {
      if (lock) tasks.lockScreen.unlock();
    });
  },
  get_all: function get_all() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(MICROSERVICE_NAME).concat(CONTROLLER_NAME, "/get_all"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  get_maintenance: function get_maintenance() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(MICROSERVICE_NAME).concat(CONTROLLER_NAME, "/get_maintenance"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  add_update_domain: function add_update_domain() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(MICROSERVICE_NAME).concat(CONTROLLER_NAME, "/add_update_domain"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      console.info(err);
    });
  }
};